import type { KioskFlowRepository } from '../data/kiosk-flow-repository';
import type { KioskFlow, KioskFlowOperatorContext } from '../types/kiosk-flow-types';
import { assertOperator, validateFlowName } from './flow-validation';

export class CreateKioskFlowUseCase {
  constructor(private readonly repository: KioskFlowRepository) {}

  async execute(ctx: KioskFlowOperatorContext, name: string): Promise<KioskFlow> {
    assertOperator(ctx);
    return this.repository.createFlow(ctx, { name: validateFlowName(name) });
  }
}
